import { KeywordFormData } from 'containers/pages/keywordManagement/types';

interface KeywordAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

const keywordFormReducer = (state: KeywordFormData, action: KeywordAction): KeywordFormData => {
  switch (action.type) {
    case 'RESET':
      return action.payload;
    default:
      if (action.type in state) {
        return { ...state, [action.type]: action.payload };
      }
      return state;
  }
};

export default keywordFormReducer;
